module.exports = __webpack_public_path__ + "static/media/GuardiansOfAether-Gallery-05.6c410cad.jpg";